module.exports = __webpack_public_path__ + "e6739f404c969d6225b48df00169ca8f.svg";